export const DELISTED_TOKENS: string[] = [
  '0x9278c8693e7328bef49804bacbfb63253565dffd', // LUNA
  '0xc74d59a548ecf7fc1754bb7810d716e9ac3e3ae5', // BUSD
]
